import {LivePenaltiesModuleTerms} from "./live-penalties-module.terms";
import {BaseConfig} from "../../infrastructure/config/base-config";

export class LivePenaltiesModuleConfig extends BaseConfig {

  static injectables = [LivePenaltiesModuleTerms];

  constructor(terms: LivePenaltiesModuleTerms) {
    super('LivePenaltiesModule', null, terms);
  }
}
